import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService, UserResponseDto } from '@/api';
import { SnackbarService } from '@/services/snackbar/snackbar.service';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- RouterStateSnapshot требуется интерфейсом ResolveFn
export const userHistoryResolver: ResolveFn<UserResponseDto | null> = (route, _state) => {
  const router = inject(Router);
  const snackbar = inject(SnackbarService);
  const userService = inject(UserService);

  const userId = Number(route.paramMap.get('userId'));
  if (!Number.isInteger(userId) || userId < 1) {
    snackbar.error('Пользователь не найден');
    router.navigate(['/users']);
    return EMPTY;
  }

  return userService.getUserById(userId).pipe(
    catchError(() => {
      snackbar.error('Пользователь не найден');
      router.navigate(['/users']);
      return EMPTY;
    }),
  );
};
